import { maxLength, minLength, notBlank } from './formValidators';

/**
 * Normalizes common backend/form values to a boolean.
 * Handles: true, false, 1, 0, "1", "0", "true", "false".
 * @param {*} value - Raw field value
 * @returns {boolean}
 */
export function normalizeBooleanField(value) {
  return value === true || value === 1 || value === '1' || value === 'true';
}

/**
 * Builds validators for checkout reference fields (product or order-level).
 * Matches backend config: min_length is enforced only when the field is
 * mandatory (`required`); optional fields may still enforce max_length.
 * @param {{ required?: boolean, min_length?: number, max_length?: number }|null|undefined} referenceField
 * @param {*} label - Field label passed into validator messages
 * @returns {Function[]}
 */
export function getReferenceFieldValidators(referenceField, label) {
  if (!referenceField) {
    return [];
  }

  const validators = [];

  if (referenceField.max_length) {
    validators.push(maxLength(label, referenceField.max_length));
  }

  if (referenceField.required) {
    validators.push(notBlank(label));
    if (referenceField.min_length > 0) {
      validators.push(minLength(label, referenceField.min_length));
    }
  }

  return validators;
}
